import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import Layout from "../components/Layout";
import MetaTags from "../lib/MetaTags";
import Breadcrumbs from "../components/Breadcrumbs";
import { ArticleCard } from "../components/ArticleCard";
import { fetchArticles, fetchCategory } from "../lib/api";
import { CATEGORIES } from "../lib/categories";

export default function Category() {
  const { slug } = useParams();
  const [cat, setCat] = useState(null);
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setLoading(true);
    Promise.all([
      fetchCategory(slug).catch(() => null),
      fetchArticles({ category: slug, limit: 24 }),
    ])
      .then(([c, list]) => {
        setCat(c);
        setItems(list.items || []);
      })
      .finally(() => setLoading(false));
  }, [slug]);

  const fallbackName = CATEGORIES.find((c) => c.slug === slug)?.name || "Category";
  const name = cat?.name || fallbackName;

  return (
    <Layout>
      <MetaTags
        title={name}
        description={cat?.description || `Browse our guides on ${name} in Chicago.`}
        image={cat?.image}
      />
      <section className="border-b border-[#121212] bg-white">
        <div className="ceg-container py-10">
          <Breadcrumbs items={[{ to: "/", label: "Home" }, { label: name }]} />
          <p className="ceg-overline mt-6">Category · {items.length} {items.length === 1 ? "guide" : "guides"}</p>
          <h1 className="font-['Outfit'] font-black tracking-tighter text-4xl sm:text-5xl md:text-6xl lg:text-7xl mt-3 leading-[0.95] break-words">{name}</h1>
          {cat?.description && (
            <p className="mt-4 text-base sm:text-lg text-[#5C5C5C] max-w-2xl">{cat.description}</p>
          )}
        </div>
        {cat?.image && (
          <div className="ceg-container pb-10">
            <div className="aspect-[21/9] overflow-hidden border border-[#121212]">
              <img src={cat.image} alt={name} className="w-full h-full object-cover" />
            </div>
          </div>
        )}
      </section>

      <section className="ceg-container py-12">
        {loading ? (
          <p className="text-sm text-[#5C5C5C]" data-testid="category-loading">Loading guides...</p>
        ) : items.length === 0 ? (
          <p className="text-sm text-[#5C5C5C]" data-testid="category-empty">No articles in this category yet.</p>
        ) : (
          <div className="grid grid-cols-12 gap-6">
            {items.map((a, i) => (
              <div key={a.slug} className="col-span-12 sm:col-span-6 lg:col-span-4">
                <ArticleCard article={a} index={i} />
              </div>
            ))}
          </div>
        )}
      </section>
    </Layout>
  );
}
